import { render, staticRenderFns } from "./WebpageEdit.vue?vue&type=template&id=22131683&scoped=true&"
import script from "./WebpageEdit.vue?vue&type=script&lang=js&"
export * from "./WebpageEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebpageEdit.vue?vue&type=style&index=0&id=22131683&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22131683",
  null
  
)

export default component.exports